import { useMemo } from "react";

import { useLocation } from "react-router-dom";

import { getCurrentRoute } from "@src/utils/routeMatcher";

const useRouteConfig = () => {
  const location = useLocation();

  const currentRouteConfig = useMemo(() => {
    const currentRoute = getCurrentRoute(location);
    return currentRoute;
  }, [ location ]);

  return currentRouteConfig;
};

export default useRouteConfig;
